import React from 'react';
import { GatsbyImage as Img, getImage } from 'gatsby-plugin-image';
import get from 'lodash/get';
import { Link } from "gatsby";

import './PostsGrid.scss';

const getPath = (pageType, slug) => {
  let section = 'blogs';

  if (['guide', 'expert-opinion'].includes(pageType)) {
    section = 'guides';
  }
  return `/${section}/${slug}`;
};

const PostsGrid = ({ posts }) => (
  <div className="posts-grid">
    {
      posts.map((post) => {
        const heroImage = getImage(get(post, 'node.heroImage'));
        const heroImageTitle = get(post, 'node.heroImage.title');
        const heading = get(post, 'node.heading');
        const topic = get(post, 'node.topic');
        const slug = get(post, 'node.slug');
        const pageType = get(post, 'node.pageType');
        const path = getPath(pageType, slug);

        return (
          <div key={heading} className="post">
            {
              heroImage && (
                <div className="post-hero-image-container">
                  <Link to={path}>
                    <Img className="post-hero-image" alt={heroImageTitle} image={heroImage} />
                  </Link>
                </div>
              )
            }
            {
              !heroImage && <div className="post-hero-image" />
            }
            <div className="post-heading">
              <Link to={path}>
                <p>{topic}</p>
                <h2>{heading}</h2>
              </Link>
            </div>
          </div>
        );
      })
    }
  </div>
);

export default PostsGrid;
